import classNames from "classnames";
import React from "react";

import {
    IReviewQueryFacets,
    ISearchFacet,
} from "../../../models/reviews.interfaces";
import { useAppSelector, useDispatchers } from "../../reducers";
import { defaultState } from "../defaults";
import { Dispatchers } from "../dispatchers";
import { FilterOption } from "./FilterOption";

import styles from "./SourceFilterSection.module.scss";

const FACET_TYPE: IReviewQueryFacets = "source_id";

export const SourceFilterSection = (): React.ReactNode => {
    const sourceFacet: ISearchFacet | null = useAppSelector((rootState) => {
        const state = rootState.reviews || defaultState;
        return (
            state.data.facets.find((facet) => facet.type === FACET_TYPE) || null
        );
    });

    const isOpen: boolean = useAppSelector((rootState) => {
        const state = rootState.reviews || defaultState;
        return state.ui.sourceFilterOpen;
    });

    const dispatchers = useDispatchers(Dispatchers);

    const onToggleVisibility = (e: React.FormEvent<HTMLInputElement>) => {
        dispatchers.updateSourceFilterVisibility(e.currentTarget.checked);
    };

    const parentClasses = classNames({
        [styles.filterTitle]: true,
        [styles.filterTitleParent]: true,
        [styles.filterTitleParentOpen]: isOpen,
    });
    const listClasses = classNames({
        [styles.list]: true,
        [styles.listParentOpen]: isOpen,
        [styles.listOpen]: isOpen,
        "customer-review__side-filters__list": true,
        "customer-review__side-filters__list--parent-open": isOpen,
        "customer-review__side-filters__list--open": isOpen,
    });
    const options = sourceFacet ? sourceFacet.options : [];
    const inputID = "source";
    return (
        <div>
            <div>
                <h3 className={parentClasses}>
                    <input
                        id={inputID}
                        type="checkbox"
                        value="Source"
                        checked={isOpen}
                        onChange={onToggleVisibility}
                        className={styles.checkbox}
                    />
                    <label htmlFor={inputID}>Sources</label>
                </h3>
                <ul className={listClasses}>
                    {options.map((option, i) => (
                        <FilterOption
                            key={i}
                            facetType={FACET_TYPE}
                            option={option}
                            showCount={true}
                        />
                    ))}
                </ul>
            </div>
        </div>
    );
};
